import { makeStyles } from "@material-ui/core/styles";

/**
 * Shared tabs and search container styling hook.
 * Reduces duplication across compensationStepDetails, pharmaCompanyPeriodRow, and pharmacyPeriodRow.
 * Provides common styles for tab layouts with integrated search functionality.
 *
 * @returns {Object} Object containing Material-UI classes
 */
const useTabsAndSearchStyles = makeStyles(theme => ({
  tabsAndSearchContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
    marginLeft: "1rem",
    marginRight: "1rem",
  },
  tabsContainer: {},
  searchContainer: {
    width: "100%",
    maxWidth: 500,
  },
  searchField: {
    width: "100%",
  },
  tab: {
    ...theme.typography.h6,
    color: theme.palette.text.hint,
    fontWeight: theme.typography.fontWeightBold,
    fontSize: "1.07rem",
  },
}));

export default useTabsAndSearchStyles;
